/**
 * Paths routed to dcf-service (via HPI_DCF_HOST) instead of control_server.
 *
 * Everything under `/dcf` goes to dcf-service — new endpoints do not need updates here.
 * Control-server APIs remain under `/control`.
 */

/**
 * @param {string} urlPath - full request path (with or without query)
 * @returns {boolean}
 */
function isDcfApiPath(urlPath) {
  const pathOnly = (urlPath || '').split('?')[0]
  return /^\/dcf(?:\/|$)/.test(pathOnly)
}

module.exports = {
  isDcfApiPath,
  DCF_API_PREFIX: '/dcf',
}
